<template>
  <div class="manage-job">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Customer</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in jobs">
            <div
              class="row clickable"
              :key="item.id"
              v-show="
                item.active == !show_deleted && item.customer_id == customer_id
              "
              v-bind:class="{ selected: item == job }"
              @click="_jobSelected(item)"
            >
              <div class="col-12">
                {{ item.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <JobDetail :job="job" class="col-12" ref="job_detail" @new="_new" />
          <NewJobModal
            ref="new_job_modal"
            v-show="showNewJobModal"
            @close="_closeNewJobModal"
            :customer_id="customer_id"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import JobDetail from "@/components/admin/job/JobDetail.vue";
import NewJobModal from "@/components/admin/job/NewJobModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Jobs",
  props: {
    customer_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    job: null,
    loading: false,
    show_deleted: false,
    showNewJobModal: false,
  }),
  watch: {
    customer_id() {
      this.job = null;
    },
    new_job(new_value) {
      this.job = new_value;
      this.$refs.new_job_modal.clear();
    },
  },
  computed: {
    ...mapState("jobs", ["jobs", "new_job"]),
  },
  methods: {
    ...mapActions("jobs", ["apiSaveJob", "apiCreateJob"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _save() {
      this.$refs.job_detail.save();
    },
    _new() {
      this.$refs.job_detail._reload();
      this.showNewJobModal = true;
    },
    _closeNewJobModal() {
      this.showNewJobModal = false;
    },
    _showTab(index) {
      this.tab = index;
    },
    _jobSelected(job) {
      this.job = job;
    },
    _delete() {
      if (this.job != null && this.job.id > 0) {
        this.job.active = !this.job.active;
        this.apiSaveJob(this.job);
      }
    },
  },
  components: {
    JobDetail,
    NewJobModal,
  },
};
</script>
